const initBenefits = function initBenefits()
{
  const benefits = document.querySelectorAll('.benefits_list__item');
  const benefitBlock = document.getElementById('benefits_detail');

  if( benefits.length > 0 ) {
    benefits.forEach( (item) => {
      item.addEventListener('click', (e) => {
        e.preventDefault();
        const benefit = e.target.nodeName == 'A' ? e.target : e.target.closest('a');
      
        benefitBlock.querySelector('h2').innerHTML = benefit.dataset.title;
        benefitBlock.querySelector('div').innerHTML = benefit.dataset.perex;
      });
    });
  }
}
export { initBenefits };